<template>
  <div class="col-12">
    <Search
      :title="$lang.qualification"
      :allowFields="$lang.qualification_fields"
      :url="url"
      :showAlert="true"
      :titleAlert="$lang.ready_qualification_alert"
      colorAlert="info"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :defaultViewCount="10"
      :dynamicButtons="dynamicButtons"
      ref="search"
    />
    <b-modal no-close-on-backdrop hide-header v-model="examPackModal" size="xl">
      <LoadingSpinner
        :loading="finalReportExamPackLoading"
        :text="$lang.updating_data"
      />
      <Search
        v-show="!finalReportExamPackLoading"
        :showAlert="true"
        :titleAlert="$lang.ready_qualification_exam_pack_alert"
        colorAlert="warning"
        :title="finalReportExamPackTitle"
        :url="finalReportExamPackUrl"
        :emptyText="$lang.no_exam_pack_exist"
        :allowFields="$lang.public_exam_pack_fields"
        :prePage="50"
        :hasSelectPerPage="false"
        :showCheckBox="true"
        :handleCheckBoxCondition="handleCheckBoxCondition"
        :showRowAllSelected="false"
        :allowOperate="false"
        :visibleAdd="false"
        @rowSelected="selectExamPack"
        @getOther="getOtherData"
      />
      <template v-slot:modal-footer>
        <b-button
          class="mr-2"
          variant="outline-danger"
          @click="examPackModal = false"
        >
          <mdicon name="close" size="20" />
          {{ $lang.close }}
        </b-button>
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      hide-header
      hide-footer
      size="lg"
      v-model="confirmData.show"
    >
      <b-card>
        <div slot="header">
          <b v-text="confirmData.title" />
        </div>
        <LoadingSpinner
          :loading="confirmData.loading"
          :text="confirmData.loadingText"
        />
        <b-row v-if="!confirmData.loading">
          <b-col>
            <b-form-group
              :label="$lang.edit_research_summary"
              :label-cols="$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.edit_research_summary"
                :rules="$v.researchSummary.$params"
              />
              <b-form-textarea
                id="researchSummary"
                type="text"
                v-model="$v.researchSummary.$model"
                :state="
                  $v.researchSummary.$dirty ? !$v.researchSummary.$error : null
                "
                autocomplete="off"
                rows="10"
              >
              </b-form-textarea>
              <b-form-invalid-feedback id="researchSummary-feedback">
                {{
                  $lang.error_required | replace($lang.edit_research_summary)
                }}
              </b-form-invalid-feedback>
            </b-form-group>
            <div v-html="confirmData.description" />
          </b-col>
          <b-col cols="12" md="12" class="text-right">
            <b-button
              class="mr-2"
              variant="outline-danger"
              @click="closeMoveToFinalReportModal"
            >
              <mdicon name="close" size="20" />
              {{ $lang.close }}
            </b-button>
            <b-button variant="success" @click="moveToFinalReport">
              <mdicon name="check" size="20" />
              {{ $lang.submitButton }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-modal>
    <Confirm
      :title="finalReportExceptionConfirmData.title"
      :description="finalReportExceptionConfirmData.description"
      :loading="finalReportExceptionConfirmData.loading"
      v-model="finalReportExceptionConfirmData.show"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      dynamicClass=""
      @cancel="closeFinalReportExceptionModal"
      @ok="updateFinalReportException"
    >
      <template slot="extra-area">
        <b-form-group
          :label="$lang.delete_reason"
          label-for="removeReason"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.delete_reason"
            :rules="$v.removeReason.$params"
          />
          <b-form-textarea
            v-model="$v.removeReason.$model"
            :placeholder="$lang.delete_reason"
            :rows="3"
            :state="$v.removeReason.$dirty ? !$v.removeReason.$error : null"
          >
          </b-form-textarea>
          <b-form-invalid-feedback id="removeReason-feedback"
            >{{ $lang.error_required | replace($lang.delete_reason) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
    </Confirm>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import Confirm from "@/components/base/confirm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, goToRoute } from "@/shared/utils";

export default {
  name: "ready-qualification",
  components: {
    Search,
    LoadingSpinner,
    Confirm,
  },
  validations: {
    researchSummary: { required },
    removeReason: {},
  },
  data() {
    return {
      dynamicButtons: [
        {
          name: "selectExamPack",
          iconFont: {
            name: "clipboard-check-multiple",
            size: "25",
            class: "text-info",
          },
          click: this.showExamPackModal,
        },
        {
          name: "moveToFinalReport",
          iconFont: {
            name: "account-plus",
            size: "25",
            class: "text-primary",
          },
          click: this.moveToFinalReportModal,
        },
        {
          name: "editView",
          iconFont: {
            name: "eye",
            size: "25",
            class: "text-success",
          },
          text: this.$lang.finalReportVotesTooltip2,
          click: this.goToFinalReportVotes,
        },
        {
          name: "delete",
          text: this.$lang.final_report_exception,
          iconFont: {
            name: "folder-remove",
            size: "25",
            class: "text-danger",
          },
          AllowPermissions: ["admin"],
          click: this.showFinalREportExceptionConfirm,
        },
      ],
      examPackModal: false,
      parvandehCode: null,
      finalReportExamPackLoading: false,
      finalReportExamPackOtherData: null,
      confirmData: {
        loading: false,
        show: false,
        title: this.$lang.move_to_final_report,
        description: "",
      },
      finalReportExceptionConfirmData: {
        loading: false,
        show: false,
        title: this.$lang.final_report_exception,
        description: "",
      },
      researchSummary: null,
      removeReason: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["report", "ready_qualification"]);
    },
    finalReportExamPackUrl() {
      return generateApiUrl(
        ["report", "final_report_exam_pack_parvandeh"],
        [this.parvandehCode]
      );
    },
    finalReportExamPackTitle() {
      const name = pathOr(
        "",
        ["parvandeh", "full_name"],
        this.finalReportExamPackOtherData
      );
      const parvandehNumber = pathOr(
        "",
        ["parvandeh", "parvandeh_number"],
        this.finalReportExamPackOtherData
      );

      return `${this.$lang.public_exam_pack_title} برای ${name} با شماره پرونده ${parvandehNumber}`;
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    goToRoute,
    showExamPackModal(item) {
      this.parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      this.examPackModal = true;
    },
    async selectExamPack(item, callback) {
      try {
        const payload = {
          resource: pathOr(null, ["resource", "name"], item),
          resource_id: pathOr(null, ["resource", "id"], item),
          parvandeh_code: pathOr(
            null,
            ["parvandeh", "code"],
            this.finalReportExamPackOtherData
          ),
          azmoon_execute_person_code: pathOr(
            null,
            ["azmoon_execute_person_code"],
            item
          ),
          exam_pack_code: pathOr(null, ["exam_pack", "code"], item),
        };
        const { selected } = item;
        if (selected) {
          await this.addExamPack(payload, callback);
        } else {
          const id = pathOr(null, ["final_report_exam_pack_id"], item);
          await this.deleteExamPack(id);
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    async addExamPack(payload, callback) {
      try {
        this.finalReportExamPackLoading = true;
        const url = generateApiUrl(["report", "final_report_exam_pack"]);
        const response = await this.$httpService.post(url, payload);
        const id = pathOr(null, ["data", "data"], response);
        callback("final_report_exam_pack_id", id);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.finalReportExamPackLoading = false;
      }
    },
    async deleteExamPack(id) {
      if (!id) return;
      try {
        this.finalReportExamPackLoading = true;
        const url = generateApiUrl(
          ["report", "final_report_exam_pack_id"],
          [id]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.finalReportExamPackLoading = false;
      }
    },
    getOtherData(data) {
      this.finalReportExamPackOtherData = data;
    },
    goToFinalReportVotes(item) {
      const name = "finalReportVotes3";
      const params = {
        code: pathOr(null, ["parvandeh", "code"], item),
      };
      goToRoute(name, params);
    },
    getData() {
      this.$refs.search.getItems();
    },
    closeMoveToFinalReportModal(item) {
      this.researchSummary = null;
      this.confirmData.show = false;
    },
    moveToFinalReportModal(item) {
      this.parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      const parvandehNumber = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const name = pathOr(null, ["person", "name"], item);
      const family = pathOr(null, ["person", "family"], item);
      const fullName = `${name} ${family}`;
      this.confirmData.description =
        this.$lang.move_to_final_report_confirm_message
          .replace(
            "{0}",
            `<strong class='text-primary'>${parvandehNumber}</strong>`
          )
          .replace("{1}", `<strong class='text-primary'>${fullName}</strong>`);
      this.confirmData.show = true;
      this.getResearchSummary(item);
    },
    async getResearchSummary(item) {
      try {
        this.confirmData.loadingText = this.$lang.receiving_data;
        this.confirmData.loading = true;
        const parvandehCode = pathOr(null, ["parvandeh", "code"], item);
        const url = generateApiUrl(
          ["report", "research_summary"],
          [parvandehCode]
        );
        const response = await this.$httpService.get(url);
        this.researchSummary = pathOr(null, ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    async moveToFinalReport() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.confirmData.loading = true;
        this.confirmData.loadingText = this.$lang.sending_data;
        const url = generateApiUrl(["report", "final_report"]);
        const payload = {
          parvandeh_code: this.parvandehCode,
          research_summary: this.researchSummary,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.confirmData.show = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmData.loading = false;
      }
    },
    closeFinalReportExceptionModal(item) {
      this.finalReportExceptionConfirmData.show = false;
    },
    showFinalREportExceptionConfirm(item) {
      this.parvandehCode = pathOr(null, ["parvandeh", "code"], item);
      const parvandehNumber = pathOr(
        null,
        ["parvandeh", "parvandeh_number"],
        item
      );
      const name = pathOr(null, ["person", "name"], item);
      const family = pathOr(null, ["person", "family"], item);
      const fullName = `${name} ${family}`;
      this.finalReportExceptionConfirmData.description =
        this.$lang.final_report_exception_confirm_message
          .replace(
            "{0}",
            `<strong class='text-primary'>${parvandehNumber}</strong>`
          )
          .replace("{1}", `<strong class='text-primary'>${fullName}</strong>`);
      this.finalReportExceptionConfirmData.show = true;
    },
    async updateFinalReportException() {
      this.$v.removeReason.$touch();
      if (this.$v.removeReason.$anyError) return;
      try {
        this.finalReportExceptionConfirmData.loading = true;
        const url = generateApiUrl(["report", "final_report_exception"]);
        const payload = {
          parvandeh_code: this.parvandehCode,
          remove_reason: this.removeReason,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.finalReportExceptionConfirmData.show = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.finalReportExceptionConfirmData.loading = false;
      }
    },
    handleCheckBoxCondition(item) {
      return (
        pathOr(0, ["exam_pack", "correction_method_algorithm_id"], item) > 1
      );
    },
  },
};
</script>
